import BoletimSection from "../BoletimSection/BoletimSection";
import ProgressBar from "../ProgressBar/ProgressBar";

import styles from "./MediaTurmaAluno.module.css";

function MediaTurmaAluno({ subjects_grades }) {
	return (
		<BoletimSection
			title={"Sua Média x Média da Disciplina"}
			icon={"medal"}
		>
			<div className={styles.labelContainer}>
				<div className={styles.label}>
					<svg
						key="dot-media-aluno"
						width="16"
						height="16"
						viewBox="0 0 16 17"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<circle
							cx="8"
							cy="8.31909"
							r="8"
							fill="#10284E"
						/>
					</svg>
					<div className={styles.labelBody}>Sua média</div>
				</div>
				<div className={styles.label}>
					<svg
						key="dot-media-turma"
						width="16"
						height="16"
						viewBox="0 0 16 17"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<circle
							cx="8"
							cy="8.31909"
							r="8"
							fill="#FEC64166"
						/>
					</svg>
					<div className={styles.labelBody}>Média da disciplina</div>
				</div>
			</div>
			<div className={styles.subjectsContainer}>
				{subjects_grades.map(({ subject, final_grade, classroom_avg }, i) => {
					const containerStyles =
						i % 2 === 1
							? styles.subjectContainer
							: [styles.subjectContainer, styles.dark].join(" ");
					return (
						<div key={`media-turma-subject-${i}`} className={containerStyles}>
							<div className={styles.subjectBody}>{subject}</div>
							<div className={styles.barsContainer}>
								<ProgressBar
									value={final_grade}
									maxValue={10}
									valueDecimal={2}
									showMaxValue={false}
									progressColor="#10284E"
								/>
								<ProgressBar
									value={classroom_avg}
									maxValue={10}
									valueDecimal={2}
									showMaxValue={false}
									progressColor="#FEC64166"
								/>
							</div>
						</div>
					);
				})}
			</div>
		</BoletimSection>
	);
}

export default MediaTurmaAluno;
